import { formatPhone } from './phone';

// BL-177 PR C7: "Reached via" on a contact card. Built from conversation history across ALL of the company's channels, matched on ALL of
// the person's phones and emails: which of OUR numbers / mailboxes this person has talked to, and how.
//   e.g. "(404) 594-2667 · text" · "Reservation@therideatl.com · email" · "WhatsApp"

// US numbers read the way staff say them: (404) 594-2667; international numbers keep their +country code.
const displayNumber = (number) => (formatPhone(number) || number).replace(/^\+1 /, '');

const lower = (value) => (typeof value === 'string' ? value.trim().toLowerCase() : '');

/** Our side of a text thread: external_thread_id is `<contactPhone>:<ourNumber>`. */
export function ourNumberFromThreadId(externalThreadId) {
    const match = /:([^:]+)$/.exec(externalThreadId || '');
    return match ? match[1].trim() : '';
}

export function matchValues(contact) {
    const phones = [...new Set((contact?.phones || [])
        .map(p => (typeof p === 'string' ? p : p?.number || p?.value || ''))
        .map(p => p.trim()).filter(Boolean))];
    const emails = [...new Set((contact?.emails || []).map(lower).filter(Boolean))];
    return { phones, emails };
}

/**
 * sessions  intake_sessions rows: { id, channel, contact_phone, contact_email, external_thread_id, email_provider_id, last_inbound_at }
 * providers map of email_provider_id -> from_email
 * Returns [{ key, text, sessionId }], newest conversation first, one entry per (our address, channel).
 */
export function reachedViaEntries(sessions, contact, providers = {}) {
    const { phones, emails } = matchValues(contact);
    const phoneSet = new Set(phones);
    const emailSet = new Set(emails);
    const newest = [...(sessions || [])].sort((a, b) =>
        String(b.last_inbound_at || b.created_at || '').localeCompare(String(a.last_inbound_at || a.created_at || '')));
    const seen = new Map();
    for (const session of newest) {
        const channel = lower(session.channel);
        let key; let text;
        if (channel === 'email') {
            if (!emailSet.has(lower(session.contact_email))) continue;
            const ours = providers[session.email_provider_id] || '';
            key = `email|${lower(ours)}`;
            text = ours ? `${ours} · email` : 'email';
        } else if (channel === 'sms' || channel === 'mms' || channel === 'whatsapp') {
            if (!phoneSet.has((session.contact_phone || '').trim())) continue;
            const ours = ourNumberFromThreadId(session.external_thread_id);
            const label = channel === 'whatsapp' ? 'WhatsApp' : 'text';
            key = `${channel === 'whatsapp' ? 'wa' : 'sms'}|${ours}`;
            text = ours ? `${displayNumber(ours)} · ${label}` : label;
        } else continue;
        if (!seen.has(key)) seen.set(key, { key, text, sessionId: session.id });
    }
    return [...seen.values()];
}
